import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { IntegrationType } from '@/types/integration';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type Response = IntegrationType[];

export const getIntegrationTypes = async (options: ReadRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(GLOBAL_SCOPE).get<EndpointResponse<Response>>('integration_type', options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
